import { gql } from '@apollo/client';

export const FORGOT_ADMIN_PASSWORD = gql`
  mutation ForgotAdminPassword($email: String!) {
    forgotAdminPassword(email: $email)
  }
`;

export const VERIFY_ADMIN_RESET_TOKEN = gql`
  mutation VerifyAdminResetToken($email: String!, $otp: String!) {
    verifyAdminResetToken(email: $email, otp: $otp)
  }
`;

export const RESET_ADMIN_PASSWORD = gql`
  mutation ResetAdminPassword($email: String!, $otp: String!, $password: String!) {
    resetAdminPassword(email: $email, otp: $otp, password: $password)
  }
`;

export const LOGIN_AS_ADMIN = gql`
  mutation LoginAsAdmin($email: String!, $password: String!) {
    loginAsAdmin(email: $email, password: $password) {
      user {
        id
        role
        firstName
        lastName
        profilePic
        dob
        email
        emailVerifiedAt
        country
        countryCode
        phone
        phoneVerifiedAt
        createdAt
      }
      token
      admin {
        id
        firstName
        lastName
        dob
        profilePic
        email
        country
        countryCode
        phone
        isSuperAdmin
      }
    }
  }
`;

export const GET_ADMIN_INFO = gql`
  query AdminInfo {
    meAdmin {
      country
      countryCode
      dob
      email
      firstName
      id
      isSuperAdmin
      lastName
      phone
      profilePic
    }
  }
`;
